import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from "./store";
import App from './App';
import { icons } from './assets/icons';
import { createRoot, hydrateRoot } from 'react-dom/client';

if (typeof process === 'undefined') {
    window.process = {
        env: {
            REACT_APP_ENV: 'dev',
        },
    };
}
//trigger build 2
React.icons = icons; // Make @coreui/icons-react & @coreui/icons work
const store = configureStore();

const rootElement = document.getElementById('root');
if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, (
        <Provider store={store}>
            <App />
        </Provider>
    ));
} else {
    const root = createRoot(rootElement);
    root.render((
        <Provider store={store}>
            <App />
        </Provider>
    ));
}
